import { API, graphqlOperation } from "aws-amplify"
import { useState, useEffect } from "react"
import * as customSubscriptions from "../customGraphql/subscriptions"

export const useProgressExcel = ({ orgId, fileId }) => {
  const [importedExcel, setImportedExcel] = useState({
    orgId: orgId,
    fileId: fileId,
    error: false,
    errorMessage: "",
    status: "PENDING",
    validation: false,
    chapters: 0,
    parts: 0,
    createdAt: "",
    updatedAt: "",
    id: fileId,
  })

  // TODO(PH-2931): stg backend historically emitted onUpdateImportProcess
  // instead of onUpdateImportExcel (branched via isStg helper, removed in this PR).
  // Verify an Excel import on stg fires next() before merge, or unify the stg backend.
  // See https://github.com/planhopper/planhopper-app/pull/151#discussion_r3720718493
  const query = customSubscriptions.onUpdateImportExcel

  useEffect(() => {
    const subscription = API.graphql(
      graphqlOperation(query, { id: fileId }),
    ).subscribe({
      next: ({ provider, value }) => {
        setImportedExcel(value.data.onUpdateImportExcel)
      },
      error: error => console.warn(error),
    })
    return () => {
      subscription.unsubscribe()
    }
  }, [])
  return importedExcel
}
